const Countries = () => {
    return ( 
        <>
        <section className="details">
        <table>
           <thead>
           <tr>
            <th>Flag </th>
            <th>Name </th>
            <th>Population</th>
            <th>Lnaguage</th>
            <th>Region</th>
            </tr>
           </thead>
           </table>
        </section>
    </>
    );
}

export default Countries;
